enum IInviteStatus {
  ACTIVATED = 'Activated',
  INVITED = 'Invited',
  DEACTIVATED = 'Deactivated',
}

export default IInviteStatus;
